module.exports = __webpack_public_path__ + "img/bnr_challenge_top_side_2.74cf6e25.png";